import { render, staticRenderFns } from "./WorkspaceAnnualProgress.vue?vue&type=template&id=78f92280&"
import script from "./WorkspaceAnnualProgress.vue?vue&type=script&lang=js&"
export * from "./WorkspaceAnnualProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports